<div class="ui grid segment backgroundcolor"
     style="height:72px;margin-bottom: 0px;margin-top: 0px;">

  <div class="ui sixteen wide column"
       style="height:100%;padding:6px; ">
    <div style="position:absolute">
      <div style="font-size: 12px;height: 12px;">
        <span style="color:#a4a4a4;padding-left: 4px;">ID </span>
        <span style="color:#a4a4a4">
                        {{this.tournamentsService.Terminal_ID}}
                    </span>
      </div>

      <div style="font-size: 12px;height: 12px;">
        <span style="color:#a4a4a4;padding-left: 4px;">V.   </span>
        <span style="color:#a4a4a4">
                        {{versionT}}
                    </span>
      </div>

      <div>
        <button class="big ui left button backgroundcolor"
                style="padding:4px;color:white;margin-top: 4px;"
                (click)="OpenPasswordModal()">
          <!--<span [ngStyle]="{'font-size': this.font40}" name="font40">{{getCurrentTime(this.tournamentsService._terminalcurrenttime)}}</span>-->
          <span>{{today | date:'HH:mm:ss'}}</span>
        </button>
      </div>
      <div (click)="this._uiHelper.setAdminScreen(false,0)">..</div>

    </div>

    <div *ngIf="this._uiHelper.isOnlyDeposit === false" style="position:absolute;left: 6%;">

      <button
        *ngIf="this._uiHelper.terminalConfig.IsLiveOn === true"
        class="big ui left attached button switchType"
        style="color:black;min-height: 56px;min-width: 173px;"
        (click)="handleSportChange('live')"
        routerLink="/LiveBets"
        [routerLinkActive]="['Allscreen_Menu_Active_Item']">

        <span style="font-size:20px">{{"LiveBetting" | t}}</span>
      </button>

      <button class="big ui right attached button switchType"
              style="color:black;min-height: 56px;min-width: 143px; border-radius:0 0 0 0;"
              (click)="handleSportChange('pre')"
              routerLink="/SportBets"
              [routerLinkActive]="['Allscreen_Menu_Active_Item']">
        <span style="font-size:20px">{{"Sports" | t}}</span>
      </button>
      <button class="big ui right attached button switchType"
              style="color:black;min-height: 56px;min-width: 143px;"
              (click)="handleSportChange('outrights')"
              routerLink="/OutRights"
              [routerLinkActive]="['Allscreen_Menu_Active_Item']">
        <span style="font-size:20px">{{"Outrights" | t}}</span>
      </button>
      <!--<button class="big ui right attached button" style="color:black" routerLink="/CustomerTransaction">
      CustomerTransaction
      </button>-->
    </div>
    <ng-template #noLiveGoalListData>
      <!-- *ngIf="this.systemName == 'bet3000' && _customerUserData?.IsTerminal == 0" -->
      <div *ngIf="this.systemName == 'bet3000' && _customerUserData?.IsTerminal == 0" class="reward-png" style="width: 100px;
      height: 56px;
      position: absolute;
    left: 35%;
    transform: scale(1.1);
      " >
          <img (click)="Open_Reward_Qr_Modal()" src="../../../Images/reward.png" style="width: 400px;
          height: 56px;
          justify-content: center;
          display: flex;
          object-fit: contain;" />

      </div>
      </ng-template>


    <div class="live-goal-list" *ngIf="this.liveGoalListData && this.liveGoalListData.length > 0 ; else noLiveGoalListData">

<!-- Live da  Gol olursa  Navbar da  Gol Animasyonu olmayacak -->

      <!-- <ng-container *ngFor="let item of this.liveGoalListData">
        <div class="lgl-row" *ngIf="item.visible">
          <div class="lgl-home-team" [ngClass]="{'goal-team': item.homeGoal == true}">{{item.homeTeam}}</div>
          <div class="lgl-score" [ngClass]="{'goal-team': item.homeGoal == true}">{{item.homeScore}}</div>
          <div class="lgl-score"> :</div>
          <div class="lgl-score" [ngClass]="{'goal-team': item.awayGoal == true}">{{item.awayScore}}</div>
          <div class="lgl-away-team" [ngClass]="{'goal-team': item.awayGoal == true}">{{item.awayTeam}}</div>
        </div>
      </ng-container> -->
      <div *ngIf="this.systemName == 'bet3000' && _customerUserData?.IsTerminal == 0" class="reward-png" style="width: 100px;
      height: 56px;
      position: absolute;
    left: 35%;
    transform: scale(1.1);
      " >
          <img (click)="Open_Reward_Qr_Modal()" src="../../../Images/reward.png" style="width: 400px;
          height: 56px;
          justify-content: center;
          display: flex;
          object-fit: contain;" />

      </div>
    </div>

    <div style="position:absolute;left: 26%;"
         id="news_ticker"
         *ngIf="this.tournamentsService._terminalnews != null && this.tournamentsService._terminalnews?.length != 0">
      <marquee style="white-space:nowrap;margin-top:5px;height:100%"
               direction="left"><span
        *ngFor="let haber of this.tournamentsService._terminalnews"
        style="color:#CFC604!important;font-size:26px;">{{haber?.CreateDate}}&nbsp;{{haber.News}}... | &nbsp;</span>
      </marquee>
    </div>

    <div style="float:right">

      <div style="margin-right: 172px" class="headerTopRightSection">
        <button style="float:left;padding: 9px;min-height: 56px;"
        class="ui button swipeContainerb3"
        (click)="openWidget.next(true)" >
  <span>SWIPE</span>
  <img src="https://sportsbookcdn.s3.eu-central-1.amazonaws.com/icons/swiper_black.png" style="width: 40px;" />
</button>

        <ng-container  *ngIf="this._uiHelper.terminalConfig.TemporaryBet == true" >
          <ng-container *ngIf="this._uiHelper.customerQrStatus">

            <button style="float:left;padding: 9px;min-height: 56px;"
                    class="ui button"
                    (click)="ExitQrCustomer()">
              <i class="sign out alternate big red icon"
                 style="margin: 0"></i>
            </button>
          </ng-container>
          <ng-container *ngIf="!this._uiHelper.customerQrStatus">
            <button style="float:left;padding: 9px;min-height: 56px;"
                    class="ui button"
                    (click)="OpenQrModal()">
              <i class="qrcode big icon"
                 style="margin: 0"></i>
            </button>
          </ng-container>

        </ng-container>
        <button [ngStyle]="{'background-color': getBalanceButtonBg()}"
                *ngIf="_customerUserData?.IsTerminal == 1"
                style="float:left;padding: 9px;min-width: 263px;min-height: 56px;"
                class="ui button"
                [ngClass]="this._uiHelper.buttonIsActive == true ? '' : 'disabled'"
                (click)="Open_Payout_Modal()">
          <i class="user big icon"></i>
          <div style="float:right">
            <div>
              <span style="font-size:17px">{{"Credit_Voucher" | t}}</span>
            </div>

            <div>
              <span *ngIf="this.Balance_Text_IsActive == 0"> </span>
              <span *ngIf="this.Balance_Text_IsActive == 1"
                    style="font-size:17px">
                  {{"BalanceCredit" | t}}:
                </span> <span
              *ngIf="this.Balance_Text_IsActive == 1"
              style="font-size:17px">
                {{_customerUserData?.Balance}}
              </span>
            </div>
          </div>
        </button>

        <button [ngStyle]="{'background-color': getBalanceButtonBg()}"
                *ngIf="_customerUserData?.IsTerminal == 0"
                style="float:left;padding: 9px;min-width: 263px;min-height: 56px;"
                class="ui button"
                [ngClass]="this._uiHelper.buttonIsActive == true ? '' : 'disabled'"
                (click)="Open_Transaction_Page()">
          <i class="credit card big icon"></i>
          <div style="float:right">
            <div>
              <span style="font-size:17px">{{_customerUserData?.UserName}}</span>
            </div>
            <div>
              <span *ngIf="this.Balance_Text_IsActive == 0"> </span>
              <span *ngIf="this.Balance_Text_IsActive == 1"
                    style="font-size:17px">{{"BalanceCredit" | t}}:</span> <span
              *ngIf="this.Balance_Text_IsActive == 1"
              style="font-size:17px">{{_customerUserData?.Balance}}</span>
            </div>
          </div>
        </button>
        <button *ngIf="!this.disableBalance" style="float:left;min-height: 56px;min-width: 75px"
                class="ui icon button"
                [ngClass]="this._uiHelper.buttonIsActive == true ? '' : 'disabled'"
                (click)="Change_Balance_Text_Status()">
          <i class="eye slash outline big icon"></i>
        </button>

      </div>

      <div style="margin-left: 395px">
        <button style="float:left;margin-right:8px;"
          class="AllScreen_Info_Button"
          [style.backgroundImage]="'url(../../../Images/icon-help.png)'"
          (click)="Open_Info_Modal()"
          *ngIf="this.activeDomain == 'wett' && !this.disableBalance"></button>


        <button style="float:left;margin-right:8px;"
         class="AllScreen_Info_Button"
         *ngIf="this.activeDomain != 'wett' && !this.disableBalance">
        </button>



        <button class="AllScreen_Language_Button"
          [style.backgroundImage]="'url(../../../Images/language-icons/' + translate.LANGCODE + '.png)'"
          *ngIf="_customerUserData?.IsTerminal == 1"
          (click)="Open_Language_Modal()">
        </button>

        <button class="AllScreen_Language_Button {{this.translate.LANGCODE}} "
        *ngIf="_customerUserData?.IsTerminal == 0">
        </button>
      </div>
    </div>
  </div>

</div>
